export default __webpack_public_path__ + "static/media/sunny.eb74d80f.jpg";